<section id="dynamic-category-header-2345674" class="editable">
  <div class="header-layout-11 dynamic-header-background">
    @if (isSearchOverlaySignal() && headerDataInput()?.searchIcon?.isVisibleOnDesktop) {
      <div class="search-drop-down-container" (click)="toggleSearchDropDown()">
        <div class="search-drop-down dynamic-header-background" (click)="$event.stopPropagation()">
          <h5 class="dynamic-header-text-color">Start your amazing search :</h5>

          <button class="close-btn" (click)="toggleSearchDropDown()">
            <img
              src="https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/close-line-icon.png"
            />
          </button>

          <base-search-bar
            [selectedDeviceType]="selectedDeviceTypeInput()"
            [headerData]="headerDataFallback"
            (searchProduct$)="searchProduct($event)"
            [searchInputControl]="searchInputControl"
            (searchIconClick$)="searchIconClick()"
            [isFocused]="isSearchOverlaySignal()"
          ></base-search-bar>
        </div>
      </div>
    }

    <!--  side menu for mobile -->
    @if (menuCollapseService.isHamburgerMenu() && headerDataInput()?.menuListVisibleOnMobile) {
      <div appClickOutside #changeHeaderMobileElement class="hamburger-menu-container" (click)="toggleHamburgerMenu()">
        <div class="hamburger-menu mobile-category-panel" (click)="$event.stopPropagation()">
          <static-menu-collapse (hideMenu$)="toggleHamburgerMenu()" [headerData]="headerDataFallback">
          </static-menu-collapse>
          @if (
            (dynamicHeaderInline() && layoutType() === 'inlineLayout1') ||
            (dynamicHeaderHover() && layoutType() === 'hoverLayout1')
          ) {
            <webstore-dynamic-menu-collapse
              #dynamicCategoryHeaderMobile
              [categories]="category() || []"
              [menuCollapseIcon]="headerDataInput()?.menuCollapseIcon || ''"
              (hideMenu$)="toggleHamburgerMenu()"
            ></webstore-dynamic-menu-collapse>
          }
        </div>
      </div>
    }

    <div class="top-section">
      <div class="logo-hamburger-wrapper">
        @if (headerDataInput()?.menuListVisibleOnMobile) {
          <div class="hamburger-btn dynamic-quick-icon-background" (click)="toggleHamburgerMenu()">
            <img class="header-hamburger-icon" [src]="headerDataInput()?.hamburgerMenuIcon" />
          </div>
        }

        @if (headerDataInput()?.searchIconMobile?.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
          <!-- Mobile search Icon -->
          <a
            class="operation-button search-btn dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
            (click)="toggleSearchDropDown()"
          >
            <img class="header-search-icon" [src]="headerDataInput()?.searchIconMobile?.searchIconMobileSrc" />
          </a>
        }

        <!-- mobile account icon -->
        @if (headerDataInput()?.accountIcon?.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
          <a
            [target]="headerDataInput()?.accountIcon?.target"
            [attr.data-click_action_value]="headerDataInput()?.accountIcon?.['data-click_action_value']"
            [attr.data-click_action_choice]="headerDataInput()?.accountIcon?.['data-click_action_choice']"
            [attr.data-section_type]="UTM_MEDIUM"
            (click)="menuCollapseService.setHamburgerMenu(false)"
            class="operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius header-account-indicator"
          >
            <img
              class="header-account-icon header-account-indicator"
              [src]="headerDataInput()?.accountIcon?.accountIconSrc"
            />
            <span class="action-label only-desktop dynamic-icon-content-text-color">
              {{ headerDataInput()?.accountIcon?.accountTextContent }}
            </span>
          </a>
        }

        <!-- mobile cart icon -->
        @if (headerDataInput()?.cartIcon?.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
          <a
            (click)="menuCollapseService.setHamburgerMenu(false)"
            class="operation-button cart-btn dynamic-quick-icon-background header-cart-indicator dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
            [target]="headerDataInput()?.cartIcon?.target"
            [attr.data-click_action_value]="headerDataInput()?.cartIcon?.['data-click_action_value']"
            [attr.data-click_action_choice]="headerDataInput()?.cartIcon?.['data-click_action_choice']"
            [attr.data-section_type]="UTM_MEDIUM"
          >
            <img class="header-cart-icon header-cart-indicator" [src]="headerDataInput()?.cartIcon?.cartIconSrc" />

            <span
              class="cart-count header-cart-indicator dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius"
              >{{ cart()?.cart_items?.length ?? 0 }}</span
            >

            <span class="action-label only-desktop dynamic-icon-content-text-color">
              {{ headerDataInput()?.cartIcon?.cartTextContent }}
            </span>
          </a>
        }

        <!-- mobile logo icon -->
        @if (headerDataInput()?.logo?.isVisibleOnMobile && selectedDeviceTypeInput() === device.mobile) {
          <a class="logo" [routerLink]="['/']">
            <img class="header-logo-icon" [src]="headerDataInput()?.logo?.logoSrc" />
          </a>
        } @else if (headerDataInput()?.logo?.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
          <!-- desktop logo icon -->
          <a class="logo" [routerLink]="['/']">
            <img class="header-logo-icon" [src]="headerDataInput()?.logo?.logoSrc" />
          </a>
        }

        @if (!isSearchOverlaySignal() && headerDataInput()?.searchIcon?.isVisibleOnDesktop) {
          <base-search-bar
            class="only-desktop"
            [selectedDeviceType]="selectedDeviceTypeInput()"
            [headerData]="headerDataFallback"
            (searchProduct$)="searchProduct($event)"
            [searchInputControl]="searchInputControl"
            (searchIconClick$)="searchIconClick()"
            [isFocused]="isSearchOverlaySignal()"
          ></base-search-bar>
        }

        @if (headerDataInput()?.contactIcon?.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
          <a
            [href]="'tel:' + headerDataInput()?.contactIcon?.contactNo"
            class="contact-btn only-desktop dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
          >
            <img [src]="headerDataInput()?.contactIcon?.contactIconSrc" />

            <div class="contact-info">
              <span class="number-message-text header-editable-text dynamic-icon-content-text-color">{{
                headerDataInput()?.contactIcon?.contactNoTextContent
              }}</span>
              <span class="mobile-number header-editable-text dynamic-icon-content-text-color">{{
                headerDataInput()?.contactIcon?.contactNo
              }}</span>
            </div>
          </a>
        }
      </div>

      <div class="operation-button-container">
        <!-- desktop account icon -->
        @if (headerDataInput()?.accountIcon?.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
          <a
            [target]="headerDataInput()?.accountIcon?.target"
            [attr.data-click_action_value]="headerDataInput()?.accountIcon?.['data-click_action_value']"
            [attr.data-click_action_choice]="headerDataInput()?.accountIcon?.['data-click_action_choice']"
            [attr.data-section_type]="UTM_MEDIUM"
            class="operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius header-account-indicator"
          >
            <img
              class="header-account-icon header-account-indicator"
              [src]="headerDataInput()?.accountIcon?.accountIconSrc"
            />
            <span class="action-label only-desktop dynamic-icon-content-text-color">
              {{ headerDataInput()?.accountIcon?.accountTextContent }}
            </span>
          </a>
        }

        <!-- desktop cart icon -->
        @if (headerDataInput()?.cartIcon?.isVisibleOnDesktop && selectedDeviceTypeInput() === device.desktop) {
          <a
            class="operation-button cart-btn dynamic-quick-icon-background header-cart-indicator dynamic-quick-icon-border-color dynamic-quick-icon-border-radius"
            [target]="headerDataInput()?.cartIcon?.target"
            [attr.data-click_action_value]="headerDataInput()?.cartIcon?.['data-click_action_value']"
            [attr.data-click_action_choice]="headerDataInput()?.cartIcon?.['data-click_action_choice']"
            [attr.data-section_type]="UTM_MEDIUM"
          >
            <img class="header-cart-icon header-cart-indicator" [src]="headerDataInput()?.cartIcon?.cartIconSrc" />

            <span
              class="cart-count dynamic-cart-count-text-color header-cart-indicator dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius"
              >{{ cart()?.cart_items?.length ?? 0 }}</span
            >

            <span class="action-label only-desktop dynamic-icon-content-text-color">
              {{ headerDataInput()?.cartIcon?.cartTextContent }}
            </span>
          </a>
        }
      </div>
    </div>
    <div class="bottom-section dynamic-menu-alignment">
      <!-- desktop navigation menu -->
      @if (headerDataInput()?.menuListVisibleOnDesktop) {
        <nav #changeHeaderElement class="navigation-wrapper mega-menu-category">
          <ul class="navigation-list static-nav">
            @for (staticMenu of headerDataInput()?.menuItems; track staticMenu.id) {
              @if (staticMenu.text !== 'Category Header') {
                <li class="editable static-menu">
                  <a
                    [ngClass]="{
                      'hover-color-active': showActiveColorSignal() && currentMenuIdSignal() === staticMenu.id,
                      'hover-color-inactive': !showActiveColorSignal() && currentMenuIdSignal() === staticMenu.id,
                    }"
                    [id]="staticMenu.id"
                    class="static-header text-hover dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu"
                    [target]="staticMenu.target"
                    [attr.data-click_action_value]="staticMenu['data-click_action_value']"
                    [attr.data-click_action_choice]="staticMenu['data-click_action_choice']"
                    [attr.data-section_type]="UTM_MEDIUM"
                    >{{ staticMenu.text }}
                  </a>
                </li>
              }
            }

            <div class="dynamic-header" #dynamicCategoryHeader>
              @if (dynamicHeaderInline() && layoutType() === 'inlineLayout1') {
                @for (parentCategory of category(); track parentCategory.id; let i = $index) {
                  <li>
                    <a
                      [routerLink]="'category/' + parentCategory?.url_path"
                      [queryParams]="{
                        utm_source: 'menu',
                        utm_medium: parentCategory?.url_path,
                      }"
                      (click)="onLinkClick()"
                      (mouseenter)="
                        getCategoryMenu({
                          utm_source: 'menu',
                          utm_medium: parentCategory?.url_path || '',
                          category_name: parentCategory.name,
                        })
                      "
                      [ngClass]="{
                        'hover-color-active': showActiveColorSignal() && currentMenuIdSignal() === parentCategory.id,
                        'hover-color-inactive': !showActiveColorSignal() && currentMenuIdSignal() === parentCategory.id,
                      }"
                      class="text-hover dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu"
                      >{{ parentCategory.name }}</a
                    >
                    @if ((parentCategory?.sub_categories?.length || 0) > 0 || (topProducts()?.length || 0) > 0) {
                      <div
                        (mouseenter)="showActiveColorSignal.set(true); currentMenuIdSignal.set(parentCategory.id)"
                        (mouseleave)="removeHoverStyle()"
                        class="submenu-container hide-sub-menu-header dynamic-sub-menu-background"
                      >
                        <div class="left-section dynamic-sub-menu-background">
                          <div class="category-container">
                            @if (parentCategory.sub_categories.length > 0) {
                              <ul class="category-list-wrapper">
                                @for (childCategory of parentCategory.sub_categories; track childCategory.id) {
                                  <ng-container *ngTemplateOutlet="categoryList; context: { $implicit: childCategory }">
                                  </ng-container>
                                }
                              </ul>
                            } @else {
                              <ng-container *ngTemplateOutlet="categoryListEmptyState"></ng-container>
                            }
                          </div>
                        </div>
                        <ng-container *ngTemplateOutlet="categoryProductCard"> </ng-container>
                      </div>
                    }
                  </li>
                }
              }

              @if (dynamicHeaderHover() && layoutType() === 'hoverLayout1') {
                <li>
                  <a
                    (click)="onLinkClick()"
                    class="text-hover dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu"
                    >{{ headerDataInput()?.categoryMenuName }}</a
                  >
                  @if ((category()?.length || 0) > 0 || (topProducts()?.length || 0) > 0) {
                    <div class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                      <div class="left-section dynamic-sub-menu-background">
                        <div class="category-container">
                          @if ((category()?.length || 0) > 0) {
                            <ul class="category-list-wrapper">
                              @for (parentCategory of category(); track parentCategory.id) {
                                <ng-container *ngTemplateOutlet="categoryList; context: { $implicit: parentCategory }">
                                </ng-container>
                              }
                            </ul>
                          } @else {
                            <ng-container *ngTemplateOutlet="categoryListEmptyState"></ng-container>
                          }
                        </div>
                      </div>

                      <ng-container *ngTemplateOutlet="categoryProductCard"> </ng-container>
                    </div>
                  }
                </li>
              }
            </div>
          </ul>
        </nav>
      }
    </div>
  </div>
</section>

<ng-template #categoryListEmptyState>
  <div class="category-empty-state">
    <img [src]="imageUrls.header11CategoryEmptyStateImage" />
  </div>
</ng-template>

<ng-template #categoryList let-category>
  @if (category.id; as catId) {
    <li
      class="category-list-item"
      [id]="'accordion' + catId"
      (mouseenter)="toggleAccordion(catId, true)"
      (mouseleave)="toggleAccordion(catId, false)"
    >
      <button
        class="sub-item-name-btn text-hover text-hover dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu"
        type="button"
        (click)="
          getProductList({
            utm_source: 'menu',
            utm_medium: category?.url_path,
            category_name: category?.name,
          })
        "
      >
        {{ category?.name }}

        @if (category.sub_categories?.length > 0) {
          <div
            [ngClass]="{
              'accordion-open': catId === hoveredCatId,
            }"
            class="accordion-icon"
          ></div>
        }
      </button>

      @if (category.sub_categories?.length > 0) {
        <div [id]="'collapse' + catId" class="collapse" [attr.data-bs-parent]="'#accordion' + catId">
          <ul class="accordion-panel category-list-sub">
            @for (sub_category of category.sub_categories; track sub_category.id) {
              <li
                class="category-list-sub-item dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu"
                (click)="
                  getProductList({
                    utm_source: 'menu',
                    utm_medium: sub_category?.url_path,
                    category_name: sub_category?.name,
                  })
                "
              >
                <span class="text-hover">
                  {{ sub_category?.name }}
                </span>
              </li>
            }
          </ul>
        </div>
      }
    </li>
  }
</ng-template>

<ng-template #categoryProductCard>
  <div class="right-section">
    <div class="submenu-card-container">
      <div class="title-wrapper">
        <h3>{{ category_name }}</h3>

        @if ((headerCategoryProducts()[category_url_paths]?.length || 0) > 4) {
          <button (click)="viewAllProducts()">View All</button>
        }
      </div>
      <div class="cards-wrapper">
        @if (loading$ | async) {
          @for (_ of [1, 2, 3, 4]; track $index) {
            <div class="shimmer-category-product-card">
              <div class="shimmer product-img"></div>
              <div class="card-content">
                <div class="shimmer brand-name"></div>
                <div class="product-name">
                  <span class="shimmer"></span>
                  <span class="shimmer"></span>
                </div>
                <div class="price-wrapper">
                  <div class="shimmer applicable-price"></div>
                  <div class="shimmer selling-price"></div>
                </div>
              </div>
            </div>
          }
        } @else {
          @if ((topProducts()?.length || 0) > 0) {
            @for (product of topProducts(); track product.id) {
              <div class="category-product-card" (click)="openProductPage(product.url_path)">
                <img class="product-img" [src]="product?.featured_images[0].url || imageUrls.noImagePlaceholder" />
                <div class="card-content">
                  <p class="brand-name">
                    {{ product.brand?.name }}
                  </p>
                  <p class="product-name" [title]="product?.display_name">
                    {{ product?.display_name }}
                  </p>
                  <div class="price-wrapper">
                    <span class="applicable-price">
                      {{ product.sellingPrice | indianCurrency }}
                    </span>
                    @if (product.sellingPrice < product.actualPrice) {
                      <span class="selling-price">
                        {{ product.actualPrice | indianCurrency }}
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
          } @else {
            <div class="category-empty-state">
              <img [src]="imageUrls.header11CategoryEmptyStateImage" />
              <h3>No products found in this category!</h3>
            </div>
          }
        }
      </div>
    </div>
  </div>
</ng-template>
